import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Histoire",
  icon: "🏛️",
  tagline: "Étudiez l'histoire de l'Afrique et du monde, développez votre esprit critique et analytique",
  duree: "3 à 5 ans",
  diplome: "Licence",
  mode: "Présentiel",
  nombreDebouches: "7",
  description: "La filière Histoire propose une formation approfondie sur l'évolution des sociétés humaines à travers les âges. Notre programme couvre l'histoire africaine, mondiale et contemporaine, tout en développant les compétences de recherche et d'analyse.",
  objectifs: [
    "Maîtriser les grandes périodes historiques",
    "Développer des compétences en recherche historique",
    "Comprendre les dynamiques sociales et politiques",
    "Acquérir une méthodologie rigoureuse",
    "Analyser les sources et documents historiques"
  ],
  programme: [
    { titre: "Licence 1 & 2", matieres: ["Histoire ancienne", "Histoire médiévale", "Histoire moderne", "Histoire de l'Afrique", "Méthodologie historique", "Géographie historique"] },
    { titre: "Licence 3", matieres: ["Histoire contemporaine", "Histoire coloniale et postcoloniale", "Historiographie", "Archives et documentation", "Histoire économique et sociale", "Histoire des idées"] }
  ],
  debouches: [
    { titre: "Enseignant", description: "Enseignement de l'histoire" },
    { titre: "Chercheur", description: "Recherche historique" },
    { titre: "Archiviste", description: "Gestion d'archives" },
    { titre: "Conservateur de musée", description: "Gestion de collections" },
    { titre: "Documentaliste", description: "Gestion documentaire" },
    { titre: "Journaliste spécialisé", description: "Journalisme historique" }
  ],
  competences: ["Maîtrise des méthodes de recherche historique", "Compétences en analyse de sources", "Esprit critique et synthèse", "Culture générale approfondie", "Capacités rédactionnelles"]
};

export default function Histoire() {
  return <FiliereTemplate filiere={filiereData} />;
}